import React from "react";

import { BlockWrapper, IntroBlock } from "components/Block";
import { FeatureItem } from "components/Feature";
import { Masonry, Container } from "components/Grid";

const Benefits = ({ content }) => {
  const breakpoints = {
    default: 2,
    700: 1
  };

  return (
    <BlockWrapper
      pt={["40px", "50px"]}
      pb={["20px", "40px"]}
      mb={["0", "50px"]}
      shade="light"
    >
      <IntroBlock content={content} shade="dark" />
      <Container mx="auto" maxWidth="1000px">
        <Masonry mt={["30px", "50px"]} breakpointCols={breakpoints}>
          {content.items.map((benefit, index) => (
            <FeatureItem
              key={index}
              content={benefit}
              shade="dark"
              mb={["10px", "20px"]}
              pr={["0", "10px"]}
            />
          ))}
        </Masonry>
      </Container>
    </BlockWrapper>
  );
};

export default Benefits;
